import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDIuzoiAZMCAD35X7z8IdPCCfzjaG718_c",
  authDomain: "vue-test-72842.firebaseapp.com",
  databaseURL: "https://vue-test-72842.firebaseio.com",
  projectId: "vue-test-72842",
  storageBucket: "vue-test-72842.appspot.com",
  messagingSenderId: "1096639111504",
  appId: "1:1096639111504:web:67806b3d1f7a21ec0e4c55",
};

firebase.initializeApp(firebaseConfig);

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
const currentUser = auth.currentUser;

const notesCollection = db.collection("notes");

// Initialize Firebase
export { notesCollection, db, auth, currentUser };
